import { Divider, Grid, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "../common/Form";
import useForm from "../common/useForm";
import Controls from "../controls/Controls";
import { forwardIssue, getDevOpsSentStatus } from "../../store/issues";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close"

const initialFormValues = {
  //issueStatus: "",
  reviewNotes: "",
  issueType: "",
};

const issueTypeItems = [
  { id: "task", title: "Task" },
  { id: "bug", title: "Bug" },
  { id: "feature", title: "Feature" },
];

const reviewTypeItems = [
  { id: "forward", title: "Forward to DevOps" },
  { id: "notForward", title: "Not Forward to DevOps" },

];

export default function ReviewForm(props) {

  const { setNotify, setOpenPopup, selectedIssue, handlReviewIssue } = props;

  const [validateOnChange, setValidateOnChange] = useState(true);
  const [reviewObj, setReviewObj] = useState({});

  const devOpsSentStatusSelector = useSelector(getDevOpsSentStatus);

  const dispatach = useDispatch();
  const validate = (fieldValues = formValues) => {
    let temp = { ...errors };
    // if ("issueStatus" in fieldValues)
    //   temp.issueStatus = fieldValues.issueStatus
    //     ? ""
    //     : "This field is required.";
    if ("reviewNotes" in fieldValues)
      temp.reviewNotes = fieldValues.reviewNotes
        ? ""
        : "This field is required.";

    setErrors({ ...temp });
    if (fieldValues === formValues)
      return Object.values(temp).every((x) => x === "");
  };

  useEffect(() => {
    if (selectedIssue) {
      setReviewObj({ reviewNotes: selectedIssue.notes, issueType: selectedIssue.type });
    }
    else {
      setReviewObj({ reviewNotes: "", issueType: "" });
    }
  }, [selectedIssue])

  const { formValues, errors, setErrors, handleOnChange, resetForm } = useForm(
    reviewObj,
    validateOnChange,
    validate,
    setValidateOnChange
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      dispatach(forwardIssue({
        id: selectedIssue.id,
        notes: formValues.reviewNotes,
        type: formValues.issueType
      }));
    }
  };

  useEffect(() => {
    if (devOpsSentStatusSelector) {
      setNotify({
        isOpen: true,
        message: "Issue Forward Successfully",
        type: "success",
      });
      resetForm();
      handlReviewIssue("save");
    }
  }, [devOpsSentStatusSelector])

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controls.RadioGroup
            name="issueReview"
            label="Issue Review"
            onChange={handleOnChange}
            items={reviewTypeItems}
            value={formValues?.review}
            row={true}
          />
        </Grid>
        <Grid item xs={12}>
          <Controls.RadioGroup
            name="issueType"
            label="Issue Type"
            onChange={handleOnChange}
            items={issueTypeItems}
            value={formValues?.issueType}
            row={true}
          />
        </Grid>
        <Grid item xs={12}>
          <Controls.Input
            multiline
            rows={3}
            name="reviewNotes"
            label="Review Notes"
            onChange={handleOnChange}
            value={formValues?.reviewNotes}
          />
        </Grid>

        <Grid item xs={12}>
          <Divider sx={{ ml: -3, mr: -3, mb: 2 }} />
          <Stack
            spacing={2}
            direction="row"
            justifyContent="end"
            alignItems="center"
          >
            <Controls.Button
              text="Close"
              color="error"
              variant="outlined"
              size="small"
              onClick={() => handlReviewIssue(null)}
              startIcon={<CloseIcon />}
              sx={{
                width:"80px",
                '&:hover': {
                  backgroundColor: 'red',
                  color: 'white',

                }
              }}
            ></Controls.Button>
            {!selectedIssue?.devOpsStatus &&
              <Controls.Button
                text="Save"
                type="submit"
                variant="outlined"
                size="small"
                startIcon={<SaveIcon />}
                sx={{
                  width:"80px",
                  color: 'black',
                  border: "1px solid black",
                  '&:hover': {
                    backgroundColor: 'black',
                    color: 'white',

                  }
                }}
              ></Controls.Button>}
          </Stack>
        </Grid>
      </Grid>
    </Form>
  );
}
